import React, { ReactNode } from 'react'
import { makeIcon } from './icons/index'

export interface CollapsiblePanelProps {
  label: string
  isOpen: boolean
  content: ReactNode
  onChange: (isOpen: boolean) => void
  className?: string
}

export const CollapsiblePanel: React.FC<CollapsiblePanelProps> = ({
  label,
  isOpen,
  content,
  onChange,
  className = '',
}) => (
  <div className={`collapsible-panel ${className}`.trim()}>
    <button
      type="button"
      className="collapsible-panel__toggle"
      onClick={() => onChange(!isOpen)}
      aria-expanded={isOpen}
    >
      <span className="collapsible-panel__label">{label}</span>
      <span className={`collapsible-panel__chevron${isOpen ? ' collapsible-panel__chevron--open' : ''}`}>
        {makeIcon('chevron-down', '24px')}
      </span>
    </button>
    <div className={`collapsible-panel__body${isOpen ? ' collapsible-panel__body--open' : ''}`} aria-hidden={!isOpen}>
      <div className="collapsible-panel__inner">
        {content}
      </div>
    </div>
  </div>
)
